import { render, staticRenderFns } from "./TrafficLight.vue?vue&type=template&id=91b0d478&"
import script from "./TrafficLight.vue?vue&type=script&lang=js&"
export * from "./TrafficLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports